import { DashboardInfoSectionCombinedProps } from './types';

const usePresenter = (props: DashboardInfoSectionCombinedProps): DashboardInfoSectionCombinedProps => {
  return props;
};

export default usePresenter;
